module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("support_tag", [["li",{"class":"menu-item"},[["a",{"href":"/support/tag/&&0&&","data-tag":""},[["span",{},[],[["alias","__text",true]]]],[["alias","href"],["alias","data-tag",true]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!../common/templates/support/leftmenu_tags.tpl
// module id = 458
// module chunks = 2